import React from 'react'
import { css } from '@linaria/core'
import { NoticeLoading } from '@fs/zion-icon'

const center = css`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export default function LoadingSpinner() {
  return (
    <div data-testid="spinner" className={center}>
      <NoticeLoading size="lg" />
    </div>
  )
}
